import * as tslib_1 from "tslib";
import { Component, Prop, Vue } from "vue-property-decorator";
let QuestionHandle = class QuestionHandle extends Vue {
    get disabledHandle() {
        // return this.paperInfo.participateCount > 0
        return false;
    }
    moveUp(index) {
        // this.paperInfo.participateCount > 0
        //   ? this.$message.error("有人参与的试卷不可以上移哦~")
        //   : this.$emit("move-up", index)
        this.$emit("move-up", index);
    }
    moveDown(index) {
        // this.paperInfo.participateCount > 0
        //   ? this.$message.error("有人参与的试卷不可以下移哦~")
        //   : this.$emit("move-down", index)
        this.$emit("move-down", index);
    }
    moveTop(index) {
        // this.paperInfo.participateCount > 0
        //   ? this.$message.error("有人参与的试卷不可以上移哦~")
        //   : this.$emit("move-top", index)
        this.$emit("move-top", index);
    }
    editList(index, question) {
        this.$emit("edit", index, question);
    }
    delList(index, question) {
        // this.paperInfo.participateCount > 0
        //   ? this.$message.error("有人参与的试卷不可以删除哦~")
        //   : this.$emit("delete", index, question)
        this.$emit("delete", index, question);
    }
};
tslib_1.__decorate([
    Prop({ type: Object, default: () => { } })
], QuestionHandle.prototype, "question", void 0);
tslib_1.__decorate([
    Prop({ type: Number, default: 0 })
], QuestionHandle.prototype, "index", void 0);
tslib_1.__decorate([
    Prop({ type: Number, default: 0, required: true })
], QuestionHandle.prototype, "questionCount", void 0);
tslib_1.__decorate([
    Prop({ type: Object, default: () => { } })
], QuestionHandle.prototype, "paperInfo", void 0);
QuestionHandle = tslib_1.__decorate([
    Component({
        name: 'QuestionHandle',
    })
], QuestionHandle);
export default QuestionHandle;
